/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Transcript_LoadingInputs */



/**
* | output |
* | --- |
* | "One moment…" |
*
* @param {Meeting_Transcript_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_transcript_loading = /** @type {((inputs?: Meeting_Transcript_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Transcript_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Even geduld…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un instant…")
	return /** @type {LocalizedString} */ ("One moment…")
});